module.exports = __webpack_public_path__ + "static/man-6acfaca09a3f7dd1d1b83ee2579909e2.png";